<template>
  <div class="loading" ref="load">
    <img :src="src" class="banner" />
    <div class="title">{{ title }}</div>
    <div class="font">
      {{ msg }}
    </div>

    <div class="jiazai">
      <div class="line" :style="'width:' + width + '%'">
        <img src="../images/car/bmwlogo.png" class="bmwlogo" />
        <div class="bmwfont">{{ loading_msg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["src", "title", "msg"],
  data() {
    return {
      //喷漆颜色列表

      loading_msg: "",
      width: 0,
    };
  },
  methods: {},

  created() {
    // var count = 0;

    // var timmer = setInterval(() => {
    //   count++;
    //   if (count == 5) {
    //     this.$message.error("小i飞速加载中,请稍后");
    //   }
    //   console.log(`加载${count}秒`);
    // }, 1000);
    document.o2vr.on_loading_msg = (a, b, c) => {
      if (b) {
        this.loading_msg = `${b}${c}`;

        this.width = b;
      }

      if (b > 99) {
        this.$refs.load.style.opacity = 0;
        this.$refs.load.style.display = "none";
      }
    };
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.loading {
  background: #fff;
  width: 100%;
  height: 100%;
  position: fixed;
  width: 100%;
  // height: 100%;
  left: 0;
  top: 0;

  z-index: 999;
  .banner {
    position: fixed;
    width: 100%;
    // height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
  }

  .title {
    position: absolute;
    font-size: 60px;
    font-family: Impact, Impact-Regular;
    font-weight: 400;
    text-align: left;
    color: #43628f;
    z-index: 4;
    right: 80px;
    top: 384px;
  }

  .font {
    position: absolute;
    width: 505px;
    font-size: 21px;
    font-family: BMW Group, BMW Group-Regular;
    font-weight: 400;
    text-align: left;
    color: #7188ad;
    line-height: 32px;
    letter-spacing: 1px;
    z-index: 4;
    right: 120px;
    top: 480px;
  }

  .jiazai {
    position: absolute;
    width: 560px;
    height: 4px;
    background: #d9e3f1;
    border-radius: 2px;
    z-index: 4;
    right: 242px;
    bottom: 228px;

    .line {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      background: #43628f;

      height: 100%;

      .bmwlogo {
        width: 17.34px;
        height: 20.01px;
        position: absolute;
        right: -8px;
        top: -10px;
      }

      .bmwfont {
        width: 30px;
        color: #43628f;
        height: 20.01px;
        font-size: 12px;
        font-family: BMW Group, BMW Group-Regular;
        font-weight: 400;
        position: absolute;
        right: -15px;
        top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 1500px) {
  .loading {
    .title {
      display: none;
    }

    .font {
      display: none;
    }

    .banner {
      height: 100%;
      width: auto;
    }

    .jiazai {
      width: 450px;
      right: 96px;
      bottom: 116px;
    }
  }
}
@media screen and (max-width: 1000px) {
  .loading {
    width: 100%;
    height: 100%;

    .title {
      font-size: 30px;
      right: 90px;
      top: 145px;
    }

    .font {
      position: absolute;
      width: 305px;
      font-size: 12px;
      line-height: 18px;
      right: 30px;
      top: 220px;
    }

    .jiazai {
      position: absolute;
      width: 320px;
      height: 4px;
      background: #d9e3f1;
      border-radius: 2px;
      z-index: 4;
      right: 80px;
      bottom: 50px;
    }
  }
}
</style>
